import { render, staticRenderFns } from "./CMS.vue?vue&type=template&id=cd5f3c46&scoped=true"
import script from "./CMS.vue?vue&type=script&lang=js"
export * from "./CMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5f3c46",
  null
  
)

export default component.exports